import { collection } from 'firebase/firestore';
import { db, auth, app, storage, googleProvider, appleProvider } from './firebaseInit';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Collection references
export const cardsCollection = collection(db, 'cards');
export const invitationsCollection = collection(db, 'invitations');
export const usersCollection = collection(db, 'users');
export const photoAlbumCollection = collection(db, 'photoAlbum');
export const sharedGroupsCollection = collection(db, 'sharedGroups');
export const connectionsCollection = collection(db, 'connections');

// Add this after your other Firebase initializations
export const analytics = getAnalytics(app);

// Helper function to get photo album reference for a user
export const getUserPhotoAlbum = (userId) => {
  return collection(db, `users/${userId}/photoAlbum`);
};

// Utility function for logging events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
};

// Re-export everything from firebaseInit
export { db, auth, app, storage, googleProvider, appleProvider };
export { app as default };

// Reference to the folders collection
export const foldersRef = collection(db, 'folders');